import { createFileRoute } from '@tanstack/react-router';

import { LineItemEditorPage } from '../features/campaigns/campaigns/components/LineItemEditor/LineItemEditorPage';

export const Route = createFileRoute(
  '/campaigns/campaigns_/overview/$campaignId_/line-items/edit/$lineItemId',
)({
  component: EditLineItemRoute,
});

function EditLineItemRoute() {
  const { campaignId, lineItemId } = Route.useParams();
  return <LineItemEditorPage campaignId={campaignId} lineItemId={lineItemId} />;
}
